import { ICellRendererParams } from "ag-grid-community";

export const payorUnassignedFacilities = [
  {
    field: "",
    header: "",
    headerCheckboxSelection: true,
    checkboxSelection: true,
    cellRenderer: (params: any) => {
      if (params.node.data.checked) {
        params.node.setSelected(true);
      }
      return params.value;
    },
  },
  {
    headerName: "Facility",
    field: "facilityname",
    editable: false,
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
  },
  {
    headerName: "Address",
    field: "address",
    editable: false,
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
  },
];
